var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25.875,
    stroke: "white",
    strokeWidth: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 18.6324C40.089 19.0493 39.1071 19.3232 38.0896 19.4543C39.1307 18.8229 39.9352 17.8224 40.3138 16.6193C39.3319 17.2149 38.2434 17.6318 37.0958 17.87C36.1612 16.8456 34.848 16.25 33.3573 16.25C30.5771 16.25 28.3056 18.5371 28.3056 21.3601C28.3056 21.7651 28.3529 22.1582 28.4357 22.5275C24.2239 22.3131 20.4736 20.2762 17.9773 17.191C17.5396 17.9415 17.2911 18.8229 17.2911 19.7521C17.2911 21.5269 18.1784 23.0993 19.5508 23.9926C18.7108 23.9926 17.93 23.7544 17.2438 23.3971V23.4328C17.2438 25.9104 18.9947 27.9831 21.3136 28.4476C20.5691 28.6528 19.7875 28.6813 19.0302 28.531C19.3516 29.5465 19.9809 30.435 20.8297 31.0717C21.6786 31.7084 22.7042 32.0613 23.7625 32.0807C21.9686 33.5107 19.7448 34.2836 17.4567 34.2725C17.0545 34.2725 16.6522 34.2487 16.25 34.201C18.4978 35.6543 21.1716 36.5 24.0347 36.5C33.3573 36.5 38.48 28.7097 38.48 21.9557C38.48 21.7294 38.48 21.515 38.4682 21.2887C39.462 20.574 40.3138 19.6687 41 18.6324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.aba69daf71d77c72fea6de12719732b9.svg";
export { ForwardRef as ReactComponent };